var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowsDesc = function SvgArrowsDesc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.287 16.54V.4H3.62v16.14l-2.407-2.407L.035 15.31l4.418 4.419 4.42-4.419-1.18-1.178zM17.462 8.161l-4.418-4.419-4.419 4.419 1.178 1.178 2.407-2.406v6.318h1.667V6.933l2.407 2.406z"
  })));
};
export default SvgArrowsDesc;